/**
 * CMS Fetching Helpers for Insightly ApS
 */

const API_BASE = 'https://api.dev.auxo.dk/public';

/**
 * Safely extracts a localized value from a CMS field.
 * Supports both resolved strings and raw localized objects.
 */
export function getLocalizedValue(field, lang = 'da') {
  if (!field) return '';
  if (typeof field === 'string') return field;
  if (typeof field === 'object') {
    return field[lang] || field['en'] || Object.values(field)[0] || '';
  }
  return String(field);
}

/**
 * Fetches a single page by its slug.
 */
export async function fetchPageBySlug(slug, lang = 'da') {
  try {
    const response = await fetch(`${API_BASE}/by-slug/${lang}/${slug}`);
    if (!response.ok) {
      throw new Error(`Failed to fetch page: ${slug} (${response.status})`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(`Error fetching page ${slug}:`, error);
    return null;
  }
}

/**
 * Fetches a collection (e.g. 'experience' or 'galleries').
 */
export async function fetchCollection(collectionName) {
  try {
    const response = await fetch(`${API_BASE}/content/${collectionName}`);
    if (!response.ok) {
      throw new Error(`Failed to fetch collection: ${collectionName} (${response.status})`);
    }
    const data = await response.json();
    return Array.isArray(data) ? data : (data.items || []);
  } catch (error) {
    console.error(`Error fetching collection ${collectionName}:`, error);
    return [];
  }
}
